// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const GROQ_MODELS = {
	"llama-3.1-8b-instant": {
		id: "llama-3.1-8b-instant",
		name: "Llama 3.1 8B",
		api: "openai-completions",
		provider: "groq",
		baseUrl: "https://api.groq.com/openai/v1",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.05,
			output: 0.08,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
	"llama-3.3-70b-versatile": {
		id: "llama-3.3-70b-versatile",
		name: "Llama 3.3 70B",
		api: "openai-completions",
		provider: "groq",
		baseUrl: "https://api.groq.com/openai/v1",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.59,
			output: 0.79,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 32768,
	} satisfies Model<"openai-completions">,
	"meta-llama/llama-4-scout-17b-16e-instruct": {
		id: "meta-llama/llama-4-scout-17b-16e-instruct",
		name: "Llama 4 Scout 17B 16E",
		api: "openai-completions",
		provider: "groq",
		baseUrl: "https://api.groq.com/openai/v1",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.11,
			output: 0.34,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 8192,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-120b": {
		id: "openai/gpt-oss-120b",
		name: "GPT OSS 120B",
		api: "openai-completions",
		provider: "groq",
		baseUrl: "https://api.groq.com/openai/v1",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0.075,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-20b": {
		id: "openai/gpt-oss-20b",
		name: "GPT OSS 20B",
		api: "openai-completions",
		provider: "groq",
		baseUrl: "https://api.groq.com/openai/v1",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.075,
			output: 0.3,
			cacheRead: 0.0375,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"openai/gpt-oss-safeguard-20b": {
		id: "openai/gpt-oss-safeguard-20b",
		name: "Safety GPT OSS 20B",
		api: "openai-completions",
		provider: "groq",
		baseUrl: "https://api.groq.com/openai/v1",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.075,
			output: 0.3,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 65536,
	} satisfies Model<"openai-completions">,
	"qwen/qwen3-32b": {
		id: "qwen/qwen3-32b",
		name: "Qwen3-32B",
		api: "openai-completions",
		provider: "groq",
		baseUrl: "https://api.groq.com/openai/v1",
		reasoning: true,
		thinkingLevelMap: {"minimal":null,"low":null,"medium":null,"high":"default"},
		input: ["text"],
		cost: {
			input: 0.29,
			output: 0.59,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 40960,
	} satisfies Model<"openai-completions">,
} as const;
